/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class LoggingService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Log a client-side event to the Breeze database
     * @returns void
     * @throws ApiError
     */
    public logToBreezeDatabase({
        requestBody,
    }: {
        /**
         * Log entry from the UI
         */
        requestBody: {
            /**
             * Severity level of the log entry.
             */
            level: 'info' | 'error';
            /**
             * Component or feature that generated the log (e.g. "SavedFilters").
             */
            source: string;
            /**
             * Human-readable description of the event.
             */
            message: string;
            /**
             * Additional structured data relevant to the event. OID is injected server-side.
             */
            context?: Record<string, any> | null;
        },
    }): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/log',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                401: `User is unauthorized.`,
                403: `Access Denied`,
            },
        });
    }

}
